import { ComponentChildren, FunctionalComponent } from 'preact'

export interface FieldContainerProps {
  inputId: string
  title: string
  children: ComponentChildren
}

const FieldContainer: FunctionalComponent<FieldContainerProps> = ({ inputId, title, children }) => {
  return (
    <div style={{ marginBottom: '16px' }}>
      <label for={inputId} style={{ marginBottom: '4px' }}>
        {title}
      </label>
      {children}
    </div>
  )
}

export default FieldContainer
